export const tasksLoading = (state) => state.tasks.loading;
export const tasksData = (state) => state.tasks.data;
export const tasksClaiming = (state) => state.tasks.claiming;
export const tasksLoaded = (state) => state.tasks.loaded;
